import { render, staticRenderFns } from "./CashflowDetail.vue?vue&type=template&id=224f0d9b&scoped=true&"
import script from "./CashflowDetail.vue?vue&type=script&lang=js&"
export * from "./CashflowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f0d9b",
  null
  
)

export default component.exports